export type DbType = 'iHistorian';

export class DbHelpers {
	private static isIHistorian(driver: string): boolean {
		return /ih.*oledb|ihistorian/gi.test(driver);
	}

	public static isOfType(dbType: DbType, driver: string): boolean {
		switch (dbType) {
			case 'iHistorian':
				return DbHelpers.isIHistorian(driver);
			// ? ...add more here
			default:
				return false;
		}
	}
}
